import { ActivityMenuItem } from "Hub/pages/TaskDetails/types";

import { MissingDataCheckEntities } from "API/Endpoints/Tasks/payloads";

import { TaskDetailsState } from "./taskDetailsStore";
import { MissingEntity } from "./types";

export const selectMenuItem = (
  state: TaskDetailsState,
  menuItems: ActivityMenuItem[]
) => {
  // if selectedMenuItemId exists and it matches a menu item
  // then do not change it
  if (
    state.selectedMenuItemId &&
    (menuItems.some((item) => item.activityId === state.selectedMenuItemId) ||
      menuItems.some((item) =>
        item.methodologies.some(
          (methodology) =>
            `${item.activityId}|${methodology.id}` === state.selectedMenuItemId
        )
      ))
  ) {
    return;
  }

  // Create methodology menu items
  const methodologyMenuItems = menuItems.flatMap((item) =>
    item.methodologies.map(
      (methodology) => `${item.activityId}|${methodology.id}`
    )
  );

  // Select the first item, if it exists
  state.selectedMenuItemId = methodologyMenuItems[0] ?? "";
};

export const flattenMissingEntities = (
  missingDataEntities: MissingDataCheckEntities
): MissingEntity[] =>
  missingDataEntities.activityMethodologies.flatMap((activity) =>
    activity.methodologies.flatMap((methodology) =>
      methodology.missingEntities.map(({ id, name, status }) => ({
        menuId: `${activity.activityId}|${methodology.id}`,
        entityId: id,
        name,
        status,
      }))
    )
  );
